import { actions as formActions } from 'react-redux-form'
import Cookie from 'js-cookie'

import * as h2Api from '../../js/h2Api'

export const SELECT_LIGHTBOX_IMAGE = 'SELECT_LIGHTBOX_IMAGE'
export const SET_TENANT_ID_FOR_UPGRADE = 'SET_TENANT_ID_FOR_UPGRADE'
export const OPEN_UPGRADE_MODAL = 'OPEN_UPGRADE_MODAL'
export const RETRIEVE_CRM_FORM = 'RETRIEVE_CRM_FORM'
export const FORM_SUBMIT = 'FORM_SUBMIT'
export const PRESELECT_QUOTE_OPTION = 'PRESELECT_QUOTE_OPTION'

export const selectLightboxImage = img => dispatch => {
  return dispatch({ type: SELECT_LIGHTBOX_IMAGE, img })
}

export const clearLightboxImage = () => dispatch => {
  return dispatch({ type: SELECT_LIGHTBOX_IMAGE, img: null })
}

export const setTenantId = tenantId => dispatch => {
  return dispatch({ type: SET_TENANT_ID_FOR_UPGRADE, tenantId })
}

export const openUpgradeModal = modalId => dispatch => {
  return dispatch({ type: OPEN_UPGRADE_MODAL, modalId })
}

export const getForm = formId => dispatch => {
  return dispatch(h2Api.get(`/api/v1/crm/form/${formId}`)({ type: RETRIEVE_CRM_FORM }))
}

export const submitHubspotForm = (formId, f) => dispatch => {
  //test account: "f68f38a6-a8ce-417b-bd5a-216d28c891e6"
  console.log(f)
  const hutk = Cookie.get('hubspotutk')

  console.log(hutk)
  const data = {
    hutk,
    fields: Object.keys(f).map(k => {
      return {
        name: k,
        value: f[k]
      }
    })
  }

  console.log(data)

  return dispatch(h2Api.post(`/api/v1/crm/submit/${formId}`, data)({ type: FORM_SUBMIT }))
}

export const isAnyPartOfElementInViewport = el => {
  const rect = el.getBoundingClientRect()
  const windowHeight = window.innerHeight || document.documentElement.clientHeight
  const inViewOrBefore = rect.top <= windowHeight - windowHeight * 0.3

  console.log(inViewOrBefore, el, windowHeight, rect)

  return inViewOrBefore
}

export const preselectOption = (fieldName, value) => dispatch => {
  return Promise.resolve(dispatch({ type: PRESELECT_QUOTE_OPTION, fieldName, value }))
}
